import { ICreateAndUpdateCategory } from "../../../types/category.interface";
import { ICreateAndUpdateDriver } from "../../../types/driver.interface";
import customAxios from "../../customAxios";
import { CREATE_CATEGORY } from "../../routes";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const createCategory = async (props: ICreateAndUpdateCategory) => {
  const body = {
    categoryName: props?.categoryName,
    type: props?.type,
    picture: props?.image,
  };

  try {
    return (await customAxios.post(CREATE_CATEGORY, body)).data;
  } catch (error: unknown) {
    console.error({ CREATE_CATEGORY: error });
    return false;
  }
};

export default createCategory;
